// extracted by mini-css-extract-plugin
module.exports = {"wrap":"modal_wrap__8COxf","header":"modal_header__2hP-3","button":"modal_button__3ErWu"};